import React from 'react';
import { layout, space, color, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Button = styled.button`
  position: relative;
  padding: 0;
  background: transparent;
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  & > span.children {
    background: ${({ isFocused }) =>
      isFocused ? themeGet('colors.primary_400') : themeGet('colors.primary_500')};
    border-radius: 8px;

    ${color}
    ${typography}

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${({ isFocused }) =>
      isFocused ? themeGet('colors.white') : themeGet('colors.primary_300')};

    & > svg {
      path {
        fill: ${({ isFocused }) =>
          isFocused ? themeGet('colors.white') : themeGet('colors.primary_300')};
      }
    }
  }

  &:hover,
  &:focus {
    background: transparent;
    outline: 0;

    & > span.children {
      background: ${themeGet('colors.primary_400')};
      color: ${themeGet('colors.white')};
      outline: 0;
    }

    & > span.children > svg {
      path {
        fill: ${themeGet('colors.white')};
      }
    }
  }

  &:disabled {
    opacity: 0.5;
  }

  ${layout}
  ${space}
`;

function BtnBack({ title, isFocused, style, children, type, onClick, disabled }) {
  return (
    <Button
      {...style}
      title={title}
      type={type}
      disabled={disabled}
      onClick={onClick}
      isFocused={isFocused}
    >
      <span className="children">{children}</span>
    </Button>
  );
}

export default BtnBack;
